import toast from "react-hot-toast";

import { useAuth } from "../contexts/authContext";

export const resolveUrl = (url) => `${process.env.REACT_APP_API_ORIGIN || ""}/napi${url.startsWith("/") ? url : `/${url}`}`;

export const useHttpMethods = () => {
  const { userData, loggedOut } = useAuth();
  const Token = userData?.accessToken;

  const parseOptions = ({ sendToken = true, jsonContent = true, headers = {}, ...rest } = {}) => {
    if (sendToken) Object.assign(headers, { Token });
    if (jsonContent) Object.assign(headers, { "Content-Type": "application/json" });
    return { headers, ...rest };
  };

  const handleError = (error) => {
    toast.error(error.msg);
  };

  const handleSuccess = (success) => {
    success.msg && toast.success(success.msg);
  };

  const httpCall = async (url, options) => {
    try {
      if (options.query) {
        const definedParams = Object.fromEntries(Object.entries(options.query).filter(([_, value]) => value !== undefined));
        url += (url.includes("?") ? "&" : "?") + new URLSearchParams(definedParams);
        delete options.query;
      }
      const response = await fetch(resolveUrl(url), options);

      if (response.ok) {
        // handleSuccess(success);
        return await safeJson(response);
      }

      if (response.status === 401 || response.status === 498) {
        loggedOut();
        throw new Error("Unauthorized");
      } else if (response.status >= 400 && response.status < 500) {
        const normalized = await safeJson(response);
        handleError(normalized);
        throw new Error(`HTTP Client Error: ${response.status}`);
      } else if (response.status >= 500) throw new Error(`HTTP Server Error: ${response.status}`);

      return await safeJson(response);
    } catch (error) {
      console.error("HTTP Error:", error.message);
      throw error;
    }
  };

  const get = (url, options = {}) => {
    const fetchOptions = parseOptions({ jsonContent: false, ...options });
    return httpCall(url, fetchOptions);
  };

  const post = (url, data, options) => {
    const fetchOptions = {
      ...parseOptions(options),
      method: "POST",
      body: JSON.stringify(data),
    };
    return httpCall(url, fetchOptions);
  };

  const put = (url, data, options) => {
    const fetchOptions = {
      ...parseOptions(options),
      method: "PUT",
      body: JSON.stringify(data),
    };
    return httpCall(url, fetchOptions);
  };

  return { get, post, put };
};

async function safeJson(response) {
  try {
    return await response.json();
  } catch (err) {
    return {};
  }
}
